const colors = {
  regularBlue: '#3F6AD5',
  tableHeader: '#F5F6FA',
  state: {
    primary: {
      light: '#00184a14',
      medium: '#4a5c9229',
    },
  },
  text: {
    secondary: '#344054',
  },
  border: {
    primary: '#D0D5DD',
  },
  primary: {
    0: '#000000',
    10: '#00184A',
    20: '#002A76',
    30: '#003FA6',
    40: '#4A5C92',
    50: '#4771DD',
    60: '#638CF9',
    70: '#8BA8FF',
    80: '#B3C5FF',
    90: '#DBE1FF',
    95: '#EEF0FF',
    99: '#FBFBFF',
    100: '#FFFFFF',
  },
  secondary: {
    0: '#000000',
    10: '#131B31',
    20: '#283047',
    30: '#3E465E',
    40: '#565E77',
    50: '#6F7691',
    60: '#8890AB',
    70: '#A3AAC7',
    80: '#BEC5E3',
    90: '#DBE1FF',
    95: '#EEF0FF',
    99: '#FBFBFF',
    100: '#FFFFFF',
  },
  tertiary: {
    0: '#000000',
    10: '#2F1400',
    20: '#4E2600',
    30: '#6F3800',
    40: '#924B00',
    50: '#B76000',
    60: '#DC7609',
    70: '#FD8F2A',
    80: '#FFB781',
    90: '#FFDCC4',
    95: '#FFEDE3',
    99: '#FFFBFF',
    100: '#FFFFFF',
  },
  error: {
    0: '#000000',
    10: '#410002',
    20: '#690005',
    30: '#93000A',
    40: '#BA1A1A',
    50: '#DE3730',
    60: '#FF5449',
    70: '#FF897D',
    80: '#FFB4AB',
    90: '#FFDAD6',
    95: '#FFEDEA',
    99: '#FFFBFF',
    100: '#FFFFFF',
  },
  neutral: {
    0: '#000000',
    10: '#18181B',
    20: '#303034',
    30: '#4A4B4F',
    40: '#646468',
    50: '#7D7E82',
    60: '#97989B',
    70: '#B0B1B5',
    80: '#C8C8CC',
    87: '#D9DADE',
    90: '#E2E2E6',
    92: '#E8E8ED',
    94: '#EEEEF2',
    95: '#EEEFF2',
    96: '#F0F0F5',
    98: '#F5F6FA',
    99: '#F8F9FC',
    100: '#FFFFFF',
  },
  neutralVariant: {
    0: '#000000',
    10: '#191B23',
    20: '#2E3038',
    30: '#45464F',
    40: '#5C5E67',
    50: '#757680',
    60: '#8F909A',
    70: '#AAAAB4',
    80: '#C5C6D0',
    90: '#E2E2EC',
    95: '#F0F0FA',
    99: '#FBFBFF',
    100: '#FFFFFF',
  },
  utility: {
    blue: {
      50: '#EFF8FF',
      200: '#B2DDFF',
      700: '#175CD3',
    },
    success: {
      50: '#ECFDF3',
      200: '#ABEFC6',
      700: '#067647',
    },
    warning: {
      50: '#FFFAEB',
      200: '#FEDF89',
      700: '#B54708',
    },
    error: {
      50: '#FEF3F2',
      200: '#FECDCA',
      700: '#B42318',
    },
    red: {
      50: '#FAEDED',
      200: '#F5DCDC',
      700: '#BA1A1A',
    },
    orange: {
      50: '#FEF6EE',
      200: '#F9DBAF',
      700: '#E04F16',
    },
    purple: {
      50: '#F4F3FF',
      200: '#D9D6FE',
      700: '#5925DC',
    },
    pink: {
      50: '#FDF2FA',
      200: '#FCCEEE',
      700: '#C11574',
    },
  },
};

const typography = {
  display: {
    large: {
      fontWeight: 500,
      fontSize: '56px',
      lineHeight: '64px',
      letterSpacing: '-0.25px',
    },
    medium: {
      fontWeight: 500,
      fontSize: '44px',
      lineHeight: '52px',
      letterSpacing: '0px',
    },
    small: {
      fontWeight: 500,
      fontSize: '32px',
      lineHeight: '42px',
      letterSpacing: '0px',
    },
  },
  headline: {
    large: {
      fontWeight: 500,
      fontSize: '30px',
      lineHeight: '40px',
      letterSpacing: '0px',
    },
    medium: {
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '36px',
      letterSpacing: '0px',
    },
    small: {
      fontWeight: 500,
      fontSize: '22px',
      lineHeight: '32px',
      letterSpacing: '0px',
    },
  },
  title: {
    large: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    medium: {
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    small: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.1px',
    },
  },
  label: {
    xLarge: {
      fontWeight: 500,
      fontSize: '18px',
      lineHeight: '26px',
      letterSpacing: '0.1px',
    },
    large: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.1px',
    },
    medium: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '0.5px',
    },
    small: {
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.5px',
    },
  },
  body: {
    xLarge: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '26px',
      letterSpacing: '0.5px',
    },
    large: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.5px',
    },
    medium: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px',
    },
    small: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0.4px',
    },
  },
};

const breakpoints = {
  small: 599,
  medium: 839,
  large: 1199,
  xlarge: 1599,
};

const spacings: Record<spacingIndex[number], string> = {
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  7: '28px',
  8: '32px',
  9: '36px',
  12: '48px',
  15: '60px',
  16: '64px',
};
type spacingIndex = [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 15, 16];

export { colors, typography, breakpoints, spacings };
